/* unplugin-vue-components disabled */import { render } from "./ai-buttons.vue?vue&type=template&id=9cace8da&scoped=true"
import script from "./ai-buttons.vue?vue&type=script&lang=js"
export * from "./ai-buttons.vue?vue&type=script&lang=js"

import "./ai-buttons.vue?vue&type=style&index=0&id=9cace8da&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cace8da"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cace8da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cace8da', __exports__)) {
    api.reload('9cace8da', __exports__)
  }
  
  module.hot.accept("./ai-buttons.vue?vue&type=template&id=9cace8da&scoped=true", () => {
    api.rerender('9cace8da', render)
  })

}


export default __exports__